<template>
  <vue-good-table :columns="columns" :search-options="{enabled: true, placeholder:'Search'}" :rows="rows"
                  :paginationOptions="{ enabled: true }"
                  :lineNumbers="payments.length ? true : false"
                  styleClass="table table-striped table-bordered m--margin-top-15">
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'amount'">
        KES {{ formatNumber(props.row.amount) }}
      </span>
      <span v-else>
          {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
    <div slot="emptystate">
      No payments to display
    </div>
    <div slot="table-actions">
      <button class="btn btn-primary" @click="loadPayHistory">
        <i class="fa fa-refresh" :class="{'fa-spin': loading }"></i>
      </button>
    </div>
  </vue-good-table>
</template>
<script>
  import api from "../../../../api";
  import helpers from "../../../../helpers";
  import config from "../../../../config";

  export default {
    name: "parking-payment-history",
    data: function () {
      return {
        loading: false,
        payments: [],
        params: this.$route.params,
        token: this.$store.state.token || window.localStorage.getItem("token"),
        columns: [
          {
            label: "Receipt No.",
            field: "receiptNo"
          },
          {
            label: "Registration No.",
            field: "regNo"
          },
          {
            label: "Payment Method",
            field: "paymentMode"
          },
          {
            label: "Date",
            field: "paymentDate",
            type: "date",
            dateInputFormat: "YYYY-MM-DD HH:mm:ss",
            dateOutputFormat: config.dateFormat
          },
          {
            label: "Amount",
            field: "amount"
          }
        ]
      };
    },
    computed: {
      rows: function () {
        return this.payments;
      }
    },
    methods: {
      formatNumber(number) {
        return helpers.formatNumber(number);
      },
      loadPayHistory() {
        const txType = "get-parking-payment-history";
        this.loading = true;
        api.request(txType, {token: this.token, countyId: this.params.countyId}).then(response => {
          if (response.data.status === "00") {
            this.loading = false;
            this.payments = response.data.paymentHistory;
          } else {
            this.loading = false;
            this.payments = [];
            console.log("No payment history found.");
          }
        });
      },
    },
    created() {
        this.loadPayHistory();
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/services/parking/datatables/PaymentHistory.vue